import React, { useEffect } from 'react';

import { HeaderContainer } from './HeaderContainer';

export const CvContainer = () => {
  useEffect(() =>{
    window.scrollTo(0,0)
  })

  const now = new Date();
  let age = now.getFullYear() - 1990;
  if (now.getMonth() > 10 || (now.getMonth() === 10 && now.getDate() >= 8)) {
    age++;
  }

  return <div className="cv">
    <HeaderContainer show={true} />
    <div className="cv-header">
        <div className="cv-header-left">
            <img src="./images/eugene.jpeg" alt="eugene" />
        </div>
        <div className="cv-header-right">
            <h1>Eugene Chugunov</h1>
            <div className="cv-header-right-info">
                <div className="cv-header-right-info-block">
                    <p><span>Age: </span>{age} years</p>
                    <p><span>City: </span>Saint-Petersburg</p>
                    <p><span>CV: </span><a target="_blank" href="./cv.pdf">Download</a></p>
                </div>
                <div className="cv-header-right-info-block">
                    <p><span>Email: </span><a href="mailto:mail@evgenius.org">mail@euchu.ru</a></p>
                    <p><span>Phone: </span><a href="phone:+7 (921) 408-22-07">+7 (921) 408-22-07</a></p>
                    <p><span>Telegram: </span><a href="https://t.me/echugunov">@echugunov</a></p>
                </div>
            </div>
        </div>
    </div>
    <div className="cv-block">
        <div className="cv-block-title">Education</div>
        <div className="cv-block-education">
          <div className="cv-block-education-title">Post-graduate courses | 2013 – 2016 </div>
          <div className="cv-block-education-place">Saint-Petersburg State University, Faculty of Applied Mathematics and Control Processes.</div>
        </div>
        <div className="cv-block-education">
          <div className="cv-block-education-title">Master of Applied Mathematics and Computer Science | 2011 – 2013 </div>
          <div className="cv-block-education-place">Saint-Petersburg State University, Faculty of Applied Mathematics and Control Processes.</div>
        </div>
        <div className="cv-block-education">
          <div className="cv-block-education-title">Bachelor of Applied Mathematics and Computer Science | 2007 – 2011</div>
          <div className="cv-block-education-place">Saint-Petersburg State University, Faculty of Applied Mathematics and Control Processes.</div>
        </div>
    </div>

    <div className="cv-block">
        <div className="cv-block-title">Experience</div>
        <div className="cv-block-job">
            <div className="cv-block-job-company">V Kontakte LLC | <a href="https://vk.com">vk.com</a></div>
            <div className="cv-block-job-position">Head of department (<span>December 2024 – Present</span>)</div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I’m managing front-end development team and mobile (iOS, Android) development team (hiring, onboarding,
                    scrum events, tasks distributing, performance review).
                </div>
                <div className="cv-block-job-description-item">I’m planning projects roadmap (quarterly and annual goals, negotiations with other teams).
                </div>
                <div className="cv-block-job-description-item">I’m managing and developing advertising user cabinet for mobile and web applications (React, React Query, Redux,
                    TypeScript).
                </div>
            </div>

            <div className="cv-block-job-separator"></div>
            <div className="cv-block-job-position">Team lead (<span>September 2022 – December 2024</span>)</div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I managed front-end development team (hiring, onboarding, scrum
                    events, tasks distributing, code review, performance
                    review).
                </div>
                <div className="cv-block-job-description-item">I planned projects roadmap (quarterly and annual
                    goals, negotiations with other teams).
                </div>
                <div className="cv-block-job-description-item">I managed and developed advertising user cabinet for
                    mobile and web applications (React, React Query, Redux,
                    TypeScript).
                </div>
                <div className="cv-block-job-description-item">I managed and developed several web client
                    applications (React, Redux, TypeScript).
                </div>
                <div className="cv-block-job-description-item">I created architecture for several new client
                    applications (React, Redux, TypeScript).
                </div>
            </div>

            <div className="cv-block-job-separator"></div>
            <div className="cv-block-job-position">Tech lead (<span>October 2021 – September 2022</span>)</div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I managed and developed advertising user cabinet for
                    mobile and web applications (React, Redux, TypeScript).
                </div>
                <div className="cv-block-job-description-item">I created architecture for 3 new client applications
                    (React, React Query, Redux, TypeScript).
                </div>
                <div className="cv-block-job-description-item">I developed several new API methods for advertising user
                    cabinet (PHP).
                </div>
                <div className="cv-block-job-description-item">I wrote unit tests for client applications (Jest).</div>
            </div>

            <div className="cv-block-job-separator"></div>
            <div className="cv-block-job-position">Senior full-stack developer (<span>April 2020 – October 2021</span>)
            </div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I developed advertising user cabinet for mobile and web
                    applications (React, Redux, TypeScript).
                </div>
                <div className="cv-block-job-description-item">I developed over 10 new API methods for advertising user
                    cabinet (PHP).
                </div>
                <div className="cv-block-job-description-item">I developed about 5 CRON crawlers for advertising user
                    cabinet (PHP).
                </div>
                <div className="cv-block-job-description-item">I wrote unit tests for client applications (Jest).</div>
            </div>
            <div className="cv-block-job-publications"><span>Publications:</span>
                <a target="_blank" rel="noopener noreferrer"
                   href="https://habr.com/ru/company/vk/blog/565166">habr.com/ru/company/vk/blog/565166</a>.
            </div>
        </div>

        <div className="cv-block-job">
            <div className="cv-block-job-company">The Recon Group LLP | <a href="https://gotrg.com">gotrg.com</a></div>
            <div className="cv-block-job-position">Team lead (<span>March 2019 – April 2020</span>)</div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I managed front-end development team (hiring, onboarding,
                    scrum events, tasks distributing, code review).
                </div>
                <div className="cv-block-job-description-item">I managed development of several web client applications
                    for SaaS system ”Returns Management Solutions”
                    (React, Redux, Sass).
                </div>
            </div>

            <div className="cv-block-job-separator"></div>
            <div className="cv-block-job-position">Senior front-end developer (<span>October 2018 – March 2019</span>)
            </div>
            <div className="cv-block-job-description"><span>Description:</span>
                <div className="cv-block-job-description-item">I developed several web client applications for SaaS
                    system ”Returns Management Solutions” (React, Redux, Sass).</div>
            <div className="cv-block-job-description-item">I created architecture of core and developed JavaScript library for making of web page screenshots. <a href="./editor">View demo</a></div>
          </div>
        </div>

        <div className="cv-block-job">
          <div className="cv-block-job-company">RingCentral, Inc | <a href="https://ringcentral.com">ringcentral.com</a></div>
          <div className="cv-block-job-position">Senior full-stack developer (<span>September 2017 – October 2018</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I created new automatic planner of events for deployment (React, Redux, Node.js, MongoDB).</div>
            <div className="cv-block-job-description-item">I have set up a continuous delivery and deployment system (Node.js, Jira webhook API, RabbitMQ, Consumers,
              Jenkins API).</div>
            <div className="cv-block-job-description-item">I created 3 CRON crawlers and parsers for Confluence pages (Node.js, Confluence API).</div>
            <div className="cv-block-job-description-item">I wrote unit tests for over 80% of functions in client and server applications (Jest, Mocha, Chai, Enzyme).</div>
          </div>

          <div className="cv-block-job-separator"></div>
          <div className="cv-block-job-position">Middle full-stack developer (<span>May 2016 – September 2017</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I created architecture and developed corporate web system for project managers and deployment team (React,
              Redux, WebSockets, Sass, Node.js, MySql, MongoDB, Nginx).</div>
            <div className="cv-block-job-description-item">I wrote unit tests for over 80% of functions in client and server applications (Jest, Mocha, Chai, Enzyme).</div>
          </div>
        </div>

        <div className="cv-block-job">
          <div className="cv-block-job-company">Saint Petersburg State University | <a href="https://apmath.spbu.ru">apmath.spbu.ru</a></div>
          <div className="cv-block-job-position">Researcher (<span>September 2014 – May 2016</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I developed over 10 mathematical models and nonlinear methods for solving them (Wolfram Mathematica).</div>
            <div className="cv-block-job-description-item">I taught databases, programming and mathematics science at the university for 5 student groups.</div>
          </div>
        </div>

        <div className="cv-block-job">
          <div className="cv-block-job-company">Freelance | <a href="https://euchu.ru">euchu.ru</a></div>
          <div className="cv-block-job-position">Middle front-end developer (<span>February 2014 – May 2016</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I created over 15 sites via Wordpress.</div>
            <div className="cv-block-job-description-item">I developed several client-side web applications (Angular, Jade, Gulp, Bower, Less).</div>
            <div className="cv-block-job-description-item">I designed over 20 sites and mobile applications (Adobe Photoshop).</div>
          </div>
        </div>

        <div className="cv-block-job">
          <div className="cv-block-job-company">ASV Studio</div>
          <div className="cv-block-job-position">Web-designer (<span>December 2011 – February 2014</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I created new designs for over 30 different pages for online furniture and lighting store.</div>
            <div className="cv-block-job-description-item">I implemented new pages on site  (HTML, CSS, Wordpress).</div>
          </div>
        </div>

        <div className="cv-block-job">
          <div className="cv-block-job-company">Virtual-art</div>
          <div className="cv-block-job-position">3D-designer (<span>December 2009 – September 2011</span>)</div>
          <div className="cv-block-job-description"><span>Description:</span>
            <div className="cv-block-job-description-item">I created over 200 different 3d models for various websites (Maxon Cinema 4d).</div>
          </div>
        </div>
    </div>
     <div className="cv-block">
      <div className="cv-block-title">Own projects</div>
       <div className="cv-block-project">
         <div className="cv-block-project-title">Image Editor for the Telegram web application</div>
         <div className="cv-block-project-description">
           <p>It is a project for Telegram Contest (result: 4th place).</p>
           <p><span>Features:</span> </p>
           <div className="cv-block-project-description-feature">The image editor includes cropper with several formats, various filters, text, stickers and brush layers.</div>
           <div className="cv-block-project-description-feature">Each layer can be added on image, changed, moved, rotated and deleted.</div>
           <p><span>Using technologies:</span> Javascript, Canvas.</p>
           <a rel="noopener noreferrer" target="_blank" href="https://entry5501-js2024r2.usercontent.dev/">View demo</a>
           <a rel="noopener noreferrer" target="_blank" href="https://github.com/morethanwords/tweb/compare/master...evgeniusorg:tweb:image_editor">GitHub</a>
         </div>
       </div>

       <div className="cv-block-project">
         <div className="cv-block-project-title">Game "Loops"</div>
         <div className="cv-block-project-description">
           <p>Modern 2D game "Loops", in which you need rotate elements for making closed chain.</p>
           <p><span>Features:</span> </p>

           <div className="cv-block-project-description-feature">
             The game is made for web and iOS (by React Native) platforms.
           </div>
           <div className="cv-block-project-description-feature">
             The game saves the user’s level.
           </div>
           <div className="cv-block-project-description-feature">
             The web game has settings for the number of rows and columns.
           </div>
           <div className="cv-block-project-description-feature">
             The iOS game has multiple themes.
           </div>
           <div className="cv-block-project-description-feature">
             The iOS game has settings of sound and vibration.
           </div>

           <p><span>Using technologies:</span> Javascript, React Native.</p>
           <a rel="noopener noreferrer" target="_blank" href="./loops">Play</a>
           <a rel="noopener noreferrer" target="_blank" href="https://github.com/evgeniusorg/loops">GitHub of web version</a>
         </div>
       </div>

      <div className="cv-block-project">
        <div className="cv-block-project-title">Charts for Telegram contest</div>
        <div className="cv-block-project-description">
          <p>Library for charts (Telegram Contest).</p>
          <p><span>Features:</span> </p>
          <div className="cv-block-project-description-feature">2 themes - dark and light.</div>
          <div className="cv-block-project-description-feature">Smart timeline navigation.</div>
          <div className="cv-block-project-description-feature">Size ~ 10 KB (3.8 KB via gzip).</div>
          <p><span>Using technologies:</span> Javascript.</p>
          <a rel="noopener noreferrer" target="_blank" href="./chart">View demo</a>
          <a rel="noopener noreferrer" target="_blank" href="https://github.com/evgeniusorg/chart">GitHub</a>
        </div>
      </div>

       <div className="cv-block-project">
         <div className="cv-block-project-title">Social network "My-travels.net"</div>
         <div className="cv-block-project-description">
           <p>My-travels.net – social network for travelers with personal travel map, travel history and infographics, search for fellow travelers and the rating of travelers.</p>
           <p><span>Features:</span> </p>
           <div className="cv-block-project-description-feature">The site has authorization through Vk.com accounts.</div>
           <div className="cv-block-project-description-feature">The site has 2 languages (English and Russian).</div>
           <div className="cv-block-project-description-feature">The site has database with 230 countries and 1 179 000 cities.</div>
           <p><span>Using technologies:</span> Angular, CoffeeScript, Jade, Less, Bower, Gulp, Amcharts, PHP, MySQL.</p>
           <p><span>Publications:</span>
             <a target="_blank" rel="noopener noreferrer" href="https://vc.ru/tribuna/24110-my-travels">vc.ru/tribuna/24110-my-travels</a>
           </p>
           <a target="_blank" rel="noopener noreferrer" href="https://my-travels.net">Visit site</a>
         </div>
       </div>
    </div>
    <div className="cv-block">
      <div className="cv-block-title">IT skills</div>
      <div className="cv-block-skils"><i>Languages:</i> JavaScript, TypeScript, PHP, Node.js, SQL, MongoDB;</div>
      <div className="cv-block-skils"><i>Libraries:</i> React, Redux, Sass, Amcharts, Jest, React Native, React Query;</div>
      <div className="cv-block-skils"><i>Applications:</i> Git, Sentry, TeamCity, PhpStorm, iTerm.</div>
    </div>
  </div>
};



// WEBPACK FOOTER //
// ./src/components/CvContainer.js